export default __webpack_public_path__ + "static/media/brain.a3843c3c.svg";